export default __webpack_public_path__ + "static/media/Analytics.52fc2706.svg";